import { isHiragana, isKatakana, toKatakana, toHiragana } from 'wanakana';
import { KeyboardLayoutObject } from 'react-simple-keyboard';

import { hiraganaLayout, abcLayout, numbersLayout } from 'components/Keyboard/Custom/Japanese/layouts';
import { SPECIAL_KEYS } from 'components/Keyboard/utils/constants';

const convertHiraganaToKatakana = (text: string) => {
  if (isHiragana(text)) {
    return toKatakana(text);
  }
  return text;
};

const convertKatakanaToHiragana = (text: string) => {
  if (isKatakana(text)) {
    return toHiragana(text);
  }
  return text;
};

export const CONVERTER: Record<string, (text: string) => string> = {
  [SPECIAL_KEYS.CONVERT]: convertHiraganaToKatakana,
  [SPECIAL_KEYS.CONVERT_HIRAGANA]: convertKatakanaToHiragana,
};

export const KEYS_TO_LAYOUT: Record<string, string> = {
  [SPECIAL_KEYS.KATAKANA]: 'katakana',
  [SPECIAL_KEYS.HIRAGANA]: 'default',
};

export const SHIFT_LAYOUTS: Record<string, string> = {
  default: 'shift',
  shift: 'default',
  katakana: 'katakanaShift',
  katakanaShift: 'katakana',
};

export const SCREEN_LAYOUTS: Record<string, KeyboardLayoutObject> = {
  [SPECIAL_KEYS.NUMBERS]: numbersLayout.layout,
  [SPECIAL_KEYS.ABC]: abcLayout.layout,
  [SPECIAL_KEYS.KANA]: hiraganaLayout.layout,
};

export const SCREEN_KEYS = new Set<string>([
  SPECIAL_KEYS.NUMBERS,
  SPECIAL_KEYS.ABC,
  SPECIAL_KEYS.KANA,
]);

